<template>
  <div
    class="push-notification"
    @mouseover="stopInterval"
    @mouseleave="startInterval"
  >
    <div class="push-notification__layout" @click="toNotifications"></div>
    <Icon iconName="Warning" iconColor="rgb(0, 117, 219)" />
    <div class="push-notification__content">
      <div class="push-notification__title">Новое уведомление</div>
      <div class="push-notification__text">
        <div
          v-if="item.description_html"
          v-html="$sanitize(formatHtml(item.description_html))"
        ></div>
        <span v-else>{{ item.NAME }}</span>
      </div>
      <div class="push-notification__action">
        <Button
          buttonSize="small"
          buttonColor="transparent"
          buttonText="Отметить прочитанным"
          @click="() => read()"
        />
      </div>
    </div>
    <div class="push-notification__row">
      <div class="push-notification__close">
        <Button
          buttonSize="small"
          buttonColor="transparent"
          buttonText=""
          iconColor="#788694"
          hasRightIcon
          iconName="Cross"
          style="width: 24px"
          @click="closeCard"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store';
import Button from 'Elements/Button/Button';
import Icon from 'Elements/Icon/Icon';
import { mixin } from '@/utils/mixins';

export default {
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      require
    }
  },
  data() {
    return {
      timeout: null,
      timeoutDelay: 10000
    };
  },
  mounted() {
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.timeout);
  },
  methods: {
    async read() {
      await store.dispatch('notifications/readNotification', this.item.id);
    },
    closeCard() {
      const readedPush = JSON.parse(
        localStorage.getItem('readedPushNotifications')
      );
      if (readedPush) {
        localStorage.setItem(
          'readedPushNotifications',
          JSON.stringify([...readedPush, this.item.id])
        );
      } else {
        localStorage.setItem(
          'readedPushNotifications',
          JSON.stringify([this.item.id])
        );
      }
      store.commit('notifications/setParam', {
        name: 'readedPush',
        val: JSON.parse(localStorage.getItem('readedPushNotifications'))
      });
    },
    toNotifications() {
      this.$router.push({ name: 'Notifications' });
    },
    startInterval() {
      this.timeout = setInterval(() => {
        if (this.timeoutDelay < 1) {
          this.closeCard();
        }
        this.timeoutDelay -= 1000;
      }, 1000);
    },
    stopInterval() {
      clearInterval(this.timeout);
    }
  },
  components: {
    Button,
    Icon
  }
};
</script>

<style lang="scss">
.push-notification {
  padding: 16px;
  border-radius: 4px;
  width: 380px;
  border-left: 4px solid $blue40;
  background: $white;
  box-shadow: 0px 4px 15px 0px rgba(33, 39, 44, 0.1);
  display: flex;
  gap: 16px;
  position: relative;

  &__layout {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  &__content {
    flex: 1;
    text-align: left;
    position: relative;
    z-index: 2;
    div * {
      max-width: 264px !important;
    }
  }
  &__title {
    color: $grey80;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 4px;
  }
  &__text {
    color: $grey80;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
  }
  &__action {
    .button-content {
      margin-left: 0 !important;
    }
  }
  &__close {
    position: relative;
    z-index: 2;
  }
}
</style>
